import { config } from '../constants/config.constant'

export const typeDelivery = (type) => {
	if (type === config.delivery.home) {
		return config.typeRetirement.home;
	}
	if (type === config.delivery.pharmacy) {
		return config.typeRetirement.pharmacy;
	}
	return type;
};
